export const initMobileMenu = () => {
    // Using event delegation so timing of script execution doesn't matter
    
    function openMobileMenu(hamburger, drawer, overlay) {
        if (!hamburger || !drawer) return;
        hamburger.classList.add('active');
        hamburger.setAttribute('aria-expanded', 'true');
        drawer.classList.add('active');
        if (overlay) overlay.classList.add('active');
        document.body.classList.add('mobile-menu-open');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
        const hamburger = document.getElementById('hamburgerToggle');
        const drawer = document.getElementById('mobileMenuDrawer');
        const overlay = document.getElementById('mobileMenuOverlay');
        
        if (hamburger) {
            hamburger.classList.remove('active');
            hamburger.setAttribute('aria-expanded', 'false');
        }
        if (drawer) drawer.classList.remove('active');
        if (overlay) overlay.classList.remove('active');
        
        document.body.classList.remove('mobile-menu-open');
        document.body.style.overflow = '';
    }

    document.addEventListener('click', function (event) {
        // Handle hamburger toggle
        const hamburger = event.target.closest('#hamburgerToggle');
        if (hamburger) {
            event.preventDefault();
            const drawer = document.getElementById('mobileMenuDrawer');
            const overlay = document.getElementById('mobileMenuOverlay');
            
            if (drawer && drawer.classList.contains('active')) {
                closeMobileMenu();
            } else {
                openMobileMenu(hamburger, drawer, overlay);
            }
            return;
        }

        // Handle close button
        const closeBtn = event.target.closest('#mobileMenuClose');
        if (closeBtn) {
            event.preventDefault();
            closeMobileMenu();
            return;
        }

        // Handle overlay click
        if (event.target.closest('#mobileMenuOverlay')) {
            closeMobileMenu();
            return;
        }
        
        // Handle dropdowns
        const linkWithChildren = event.target.closest('.mobile-nav-menu .menu-item-has-children > a');
        if (linkWithChildren) {
            event.preventDefault();
            linkWithChildren.parentElement.classList.toggle('active');
        }
    });

    const header = document.querySelector('.site-header');
    if (header) {
        const handleScroll = () => {
            header.classList.toggle('is-sticky', window.scrollY > 200);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
    }

    window.addEventListener('resize', function () {
        if (window.innerWidth > 991) {
            closeMobileMenu();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeMobileMenu();
        }
    });
};
